module.exports = __webpack_public_path__ + "common/icon-share-button-8c9bef8e8f840254d0aeb8a4ede87fd1.svg";